import { render, staticRenderFns } from "./ExpensesSetting.vue?vue&type=template&id=ddaf6e1a"
import script from "./ExpensesSetting.vue?vue&type=script&lang=js"
export * from "./ExpensesSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports